import React from 'react';
import PropTypes from 'prop-types';
import AdvInput, { advInputTextChanged } from '../../../CommonComponents/AdvInput';
import AdvForm from '../../../CommonComponents/AdvForm';
import AdvInputWrapper from '../../../CommonComponents/AdvInputWrapper';
import { isNumeric, createCustomPropType, isUuid } from '../../../../js/app/react/validators';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';

const { ADV } = window;

const View = ({
  clientId,
  title,
  groupTitle,
  areOptionsLoaded,
  goalId,
  whatIfType,
  storeData,
  hasSpouse,
  principalName,
  spouseName,
  principalAdditionalCoverage,
  spouseAdditionalCoverage,
}) => (
  <div className="what-ifs-layout-content">
    <h4 className="what-if-group-title">{groupTitle}</h4>
    <AdvForm>
      <ValidationErrors clientId={clientId} />
      <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
        <li className="what-ifs-form-field">
          <h5 className="what-if-title">{title}</h5>
        </li>
        <li className="what-ifs-form-field">
          <label
            className="what-ifs-insurance-label"
            htmlFor="PrincipalAdditionalCoverage"
          >
            <span className="what-ifs-label-text">{principalName}</span>
            <br />
            <AdvInputWrapper hasCurrency className="what-ifs-input-wrapper">
              <AdvInput
                autoComplete="off"
                id="PrincipalAdditionalCoverage"
                type="text"
                dataType="money"
                maxLength="14"
                onBlur={advInputTextChanged(
                  clientId,
                  storeData(goalId, whatIfType),
                  'WhatIf.PrincipalAdditionalCoverage',
                )}
                value={ADV.util.formatValue(principalAdditionalCoverage, 'money')}
                className="what-ifs-input"
              />
            </AdvInputWrapper>
          </label>
        </li>
        {hasSpouse && (
          <li className="what-ifs-form-field">
            <label
              className="what-ifs-insurance-label"
              htmlFor="SpouseAdditionalCoverage"
            >
              <span className="what-ifs-label-text">{spouseName}</span>
              <br />
              <AdvInputWrapper hasCurrency className="what-ifs-input-wrapper">
                <AdvInput
                  autoComplete="off"
                  id="SpouseAdditionalCoverage"
                  type="text"
                  dataType="money"
                  maxLength="14"
                  onBlur={advInputTextChanged(
                    clientId,
                    storeData(goalId, whatIfType),
                    'WhatIf.SpouseAdditionalCoverage',
                  )}
                  value={ADV.util.formatValue(spouseAdditionalCoverage, 'money')}
                  className="what-ifs-input"
                />
              </AdvInputWrapper>
            </label>
          </li>
        )}
      </ul>
    </AdvForm>
  </div>
);
View.defaultProps = {
  title: '',
  groupTitle: '',
  spouseName: '',
  spouseAdditionalCoverage: 100,
};

View.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  whatIfType: PropTypes.number.isRequired,
  storeData: PropTypes.func.isRequired,
  hasSpouse: PropTypes.bool.isRequired,
  principalName: PropTypes.string.isRequired,
  spouseName: PropTypes.string,
  spouseAdditionalCoverage: PropTypes.number,
  principalAdditionalCoverage: PropTypes.number.isRequired,
};

export default View;
